<template>
  <v-container fluid>
    <v-navigation-drawer app fixed clipped width="400">
      <template v-slot:prepend :elevation="3">
        <v-list-item>
          <v-list-item-title>{{ $t("search") }}</v-list-item-title>
        </v-list-item>
        <!-- <v-list-item>
          <v-text-field prepend-inner-icon="mdi-magnify" rounded solo>
          </v-text-field>
        </v-list-item> -->
        <v-divider></v-divider>
      </template>
      <template v-slot:append :elevation="3">
        <v-divider></v-divider>
        <div class="d-flex pa-4">
          <v-btn color="primary" class="mr-4" @click="filter()">{{
            $t("apply_filter")
          }}</v-btn>
          <v-btn color="primary" @click="clearFilter()">{{
            $t("cancel")
          }}</v-btn>
        </div>
      </template>

      <div class="pa-2">
        <filter-part ref="filterView"> </filter-part>
      </div>
    </v-navigation-drawer>
    <div class="main-container" fill-height>
      <entity-view
        :item-schemas="itemSchemas"
        :readonly="readonly"
        :items="items"
        :title="$t('customer')"
        :pagination="pagination"
        :externalActions="externalActions"
        :options="options"
        @items-refresh="itemsRefresh"
        @item-action="itemAction"
        @page-change="pageChange"
        @double-click-row="clickRow"
      >
        <template v-slot:icon="item">
          <v-icon v-if="item.value" small color="success">
            mdi-check-circle
          </v-icon>
          <v-icon v-if="!item.value" small color="error">
            mdi-close-circle
          </v-icon>
        </template>
      </entity-view>
    </div>
    <input-dialog></input-dialog>
  </v-container>
</template>

<script>
import EntityView from "../components/EntityView.vue";
import InputDialog from "../components/InputDialog.vue";
import FilterPart from "./FilterPart.vue";

export default {
  components: { EntityView, InputDialog, FilterPart },
  data: () => ({
    title: "Lawyer",
    select: true,
    expendOpen: false,
    readonly: true,
    expendFilter: {
      effected: {
        last: 10,
      },
    },
    pagination: {
      current: 1,
      pageCount: 1,
      pageSize: 10,
    },
    itemSchemas: [
      {
        name: "id",
        value: "id",
        type: "int",
      },
      {
        name: "nickname",
        value: "nickname",
        type: "string",
        hasfilter: true,
        condition: {},
      },
      {
        name: "phoneNumber",
        value: "phoneNumber",
        type: "string",
        hasfilter: true,
        condition: {},
      },
      {
        name: "email",
        value: "email",
        type: "string",
        hasfilter: true,
        condition: {},
      },
      {
        name: "isActive",
        value: "active",
        type: "boolean",
        template: "icon",
        hasTemplate: true,
      },
    ],
    items: [],
    externalActions: [],
  }),
  mounted() {
    this.updateSchemaData();
    this.refresh();
  },
  computed: {
    options: function () {
      return {
        dateTimePattern: this.$root.$config.dateTimePattern,
        datePattern: this.$root.$config.datePattern,
        showAction: false,
      };
    },
  },
  methods: {
    updateSchemaData() {
      this.localizeSchema(this.itemSchemas);
      this.$refs.filterView.loadSchema(this.itemSchemas);
    },
    refresh() {
      let _this = this;
      let postData = {
        pagination: this.pagination,
        criterias: this.$refs.filterView.getCriterias(),
      };
      this.post("/api/users?type=user", postData, {
        callback: function (data) {
          let pg = {
            pageCount: data.data.pages,
            pageSize: data.data.size,
            current: data.data.current,
          };
          _this.pagination = pg;
          _this.items = data.data.records;
        },
      });
    },
    itemsRefresh() {
      this.refresh();
    },
    clickRow(item) {
      this.$router.push({
        name: "CustomerDetail",
        params: { id: item.id + "" },
      });
    },
    itemCreate() {
      this.$router.push({ name: "CustomerDetail" });
    },
    filter() {
      this.refresh();
    },
    clearFilter() {
      this.$refs.filterView.clear();
    },
    pageChange(pagination) {
      this.pagination = pagination;
      this.refresh();
    },
    itemAction(name) {
      if (name === "insert") {
        this.itemCreate();
      }
    },
  },
};
</script>

<style scoped>
.filter-label {
  margin-left: -12px !important;
}
</style>

<i18n>
{
  "en": {
  },
  "cn": {
  }
}
</i18n>
